export default "__VITE_ASSET__CaDLn2wf__"